<template>
  <div class="wrap-box">
    <div class="box">
      <p class="box-title">{{words.PersonalInformation}}</p>
      <div class="form-box">
        <div class="userinfo">
          <img :src="user.avatar || userinfo.avatar" alt="" class="avatar">
          <div class="mobile-box">
            <p class="tit">{{words.AccountNumber}}</p>
            <p class="mobile">{{user.tel}}</p>
          </div>
        </div>
        <div class="from">
          <div class="item">
              <p class="tit">{{words.Nickname}}</p>
             <Input  class="input"  size="large" v-model="user.name"/>
          </div>
          <!-- <div class="item">
              <p class="tit">{{words.Identifier}}</p>
              <Input  class="input"  size="large"  disabled/>
          </div> -->
          <div class="item">
              <p class="tit">{{words.Birthday}}</p>
              <DatePicker type="date"  class="input"  size="large" v-model="user.birthday"/></DatePicker>
          </div>
          <div class="item">
            <p class="tit">{{words.Area}}</p>
               <Cascader class="input" :data="city" v-model="value2"  size="large"></Cascader>
          </div>
          <div class="item">
            <p class="tit">{{words.Email}}</p>
              <Input  class="input"  size="large" v-model="user.email"/>
          </div>
          <p class="btn" @click="SaveUserInfo">{{words.Save}}</p>
        </div>
        
      </div>
      <div class="form-box" v-if="staff">
        <div class="from">
          <div class="item">
              <p class="tit">{{words.Company}}</p>
             <Input  class="input" disabled size="large" v-model="staff.company_name"/>
          </div>
          <div class="item dis">
              <div>
                <p class="tit">{{words.Department}}</p>
                <Input  class="input" disabled size="large" v-model="staff.department_name"/>
              </div>
              <div>
                <p class="tit">{{words.Type}}</p>
                <Input  class="input" disabled size="large" v-model="staff.pay_type ? words.shared : words.quota"/>
              </div>
          </div>
           <div class="item">
              <p class="tit">{{words.AvailableFeatures}}</p>
             <Input  class="input" disabled size="large" v-model="staff.powerText"/>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <p class="box-title">{{words.ScanConfiguration}}</p>
      <div class="form-box">
        <div class="from">
          <div class="item mr">
              <p class="tit">{{words.ScanToEmail}}</p>
             <Input  class="input" :placeholder="words.PleaseInputTheEmailAddress" size="large" v-model="scan.email"/>
          </div>
        </div>
        <div class="hr"></div>
        <div class="from">
          <div class="item mr">
              <p class="tit">{{words.ScanToLocalDirectory}}</p>
              <Input  class="input"  :placeholder="words.DomainServer" size="large" autocomplete="new-password" v-model="scan.ip"/>
              <Input  class="input"  :placeholder="words.DirectoryAddress" size="large"  autocomplete="new-password" v-model="scan.address"/>
              <Input  class="input"  :placeholder="words.LoginAccount" size="large" autocomplete="new-password" v-model="scan.code"/>
              <Input  class="input"  :placeholder="words.LoginPassword" size="large" autocomplete="new-password" v-model="scan.password"/>
          </div>
           <p class="btn" @click="SaveScanConfig">{{words.Save}}</p>
        </div>
      </div>
    </div>
    <div class="box">
      <p class="box-title">{{words.AccountSecurity}}</p>
        <div class="form-box">
          <div class="from">
            <div class="item">
              <p class="tit">{{words.AccountPassword}}</p>
              <Input  class="input" autocomplete="new-password" type="password" :placeholder="user.pass ? '******' : words.NotSet" size="large" v-model="password" />
              <p class="pass-btn" @click="SavePassword">{{words.SetPassword}}</p>
            </div>
            <div class="item">
              <p class="tit">{{words.ThirdPartyBinding}}</p>
             <div class="login-item">
                <i class="icon talk"></i>
                <span class="name">{{words.DingTalk}}</span>
                <p class="bind unbind" @click="DingTalkUnBind" v-if="user.dd_web_openid"><span>{{words.Unbind}}</span></p>
                <p class="bind" @click="LoginMenuChange(1)" v-else><span>{{words.Bind}}</span></p>
             </div>
             <div class="login-item">
                <i class="icon wechat"></i>
                <span class="name"><span>{{words.WeChat}}</span></span>
                <p class="bind unbind" v-if="user.web_openid" @click="WechatUnBind"><span>{{words.Unbind}}</span></p>
                <p class="bind" @click="LoginMenuChange(0)" v-else><span>{{words.Bind}}</span></p>
             </div>
            </div>
          </div>
          
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import cityData from '../../utils/city.data';
import config from '../../config/index'
import { setTimeout } from 'timers';
export default {
  components: {},
  data() {
    return {
      userinfo:{
        avatar:require("../../assets/login_192.png"),
      },
      city:[],
      value2: [],
      staff:false,
      scan:{
        email:"",
        ip:"",
        code:"",
        code:"",
        password:""
      },
      password:""
    };
  },
  mounted() {
    this.city = cityData;
    cityData.map(item=>{
      item.value = item.label
      item.children.map(val=>{
        val.value = val.label;
        val.children.map(value=>{
          value.value = value.label
        })
      })
    })
    this.GetUserInfo().then(res=>{
      res.data.token = this.user.token;
      if(!this.scan.email) this.scan.email = this.user.email;
      if(!res.data.email) res.data.email = this.scan.email;
      this.setUser(res.data);
      if(this.user.is_staff) this.GetStaff();
    })
    if(this.user.area) this.value2 = this.user.area.split(',');
    
    this.GetScan();
    console.log(111111,this.$route);
    if(this.$route.query.code && this.$route.params.mode == 1) this.DingTalkBind(this.$route.query.code)
    else if(this.$route.query.code) this.WechatBind(this.$route.query.code)

  },
  methods: {
    ...mapActions(["setUser", "GetUserInfo","GetUserStaff","GetScanConfig","SetUserInfo","SetScanConfig","GetWechatUserInfo","DingTalkLogin"]),
    GetStaff(){
      this.GetUserStaff().then(res=>{
        let power = {
          Scan:"扫描文件",
          MonoCopy:"黑白复印",
          ColorCopy:"彩色复印",
          MonoPrint:"黑白打印",
          ColorPrint:"彩色打印"
        },powerText = [];
        if(res.data.machine_power == '' || !res.data.machine_power){
          for (let i in power) {
              powerText.push(power[i])          
          }
        }else {
          let data = JSON.parse(res.data.machine_power);
          for (let i in data) {
             if(data[i]){
               powerText.push(power[i]);
             }        
          }
        }
        res.data.powerText = powerText.join(',');
        this.staff = res.data;

      })
    },
    GetScan(){
      this.GetScanConfig().then(res=>{
          this.scan = res.data;
      })
    },
    SaveUserInfo(){
      this.SetUserInfo({
        name:this.user.name,
        birthday:this.user.birthday,
        area:this.value2.join(','),
        email:this.user.email
      }).then(res=>{
        
        if(res.code === 1) 
        {
          this.$Message.success(res.msg)
          this.GetUserInfo().then(res=>{
            res.data.token = this.user.token;
            this.setUser(res.data);
          })
        }else  this.$Message.error(res.msg)
      })
    },
    SaveScanConfig(){
      console.log(this.$lfy.check.isEmail(this.scan.email))
        if(this.scan.email && !this.$lfy.check.isEmail(this.scan.email)){
          this.$Message.error('邮箱错误');
            return
        }
       
         if(this.scan.ip && this.scan.ip.split('.').length < 4){
          this.$Message.error('域服务器填写错误');
					return
        }
         if(this.scan.ip && !this.scan.address){
          this.$Message.error('请输入目录地址');
					return
        }else if(this.scan.address){
					let address = this.scan.address,
						strArr = address.split('/'),
						strNum = 0,
						strArr1 = [];
					strArr.map(item => {
						if (item !== '') strArr1.push(item);
					})
					for (let i = 0; i < address.length; i++) {
						if (address[i] == '/') {
							strNum++;
						}
					}
					console.log(JSON.stringify(strArr1));
					if (strNum < 1 || strArr1.length !== strNum) {
					 this.$Message.error('目录地址错误');
						return
			  	}
        }
				if(this.scan.ip && !this.scan.code){
           this.$Message.error('请输入登录账号')
					return
				}
				if(this.scan.ip && !this.scan.password){
          this.$Message.error('请输入密码')
					return
				}
      this.SetScanConfig(this.scan).then(res=>{
        this.$Message.success("修改成功");
      })
    },
    SavePassword(){
      if(!this.password) {
        this.$Message.error("请输入密码");
        return false;
      }
      if(this.password.length < 6) {
        this.$Message.error("密码不得少于6位");
        return false;
      }
      this.SetUserInfo({
        password:this.password,
      }).then(res=>{
        if(res.code){
           this.GetUserInfo().then(res=>{
            res.data.token = this.user.token;
            this.setUser(res.data);
          })
           this.$Message.success("设置密码成功");
        }else{
           this.$Message.error(res.msg || "设置密码失败");
        }
      })
    },
    LoginMenuChange(e) {
      if (e === 0) {
        const redirect_uri = encodeURIComponent (
          `https://${location.host}/#/info/0/`
        );
        const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${config.WechatOpen.AppId}&redirect_uri=${redirect_uri}&scope=snsapi_login&state=${new Date().getTime()}#wechat_redirect`;
        window.location.href = url;
      }else{
       const redirect_uri = encodeURIComponent(
          `https://${location.host}/#/info/1/`
        );
        const url = `https://oapi.dingtalk.com/connect/qrconnect?appid=${config.Dingtalk.AppId}&response_type=code&scope=snsapi_login&state=${new Date().getTime()}&redirect_uri=${redirect_uri}`;
        console.log(redirect_uri)
        window.location.href = url;
      }
    },
    WechatBind(code){
      this.GetWechatUserInfo({code}).then(res=>{
        if(res.code !== 5) {
          this.$Message.error('绑定失败，请重试')
          return false;
        }
        let data = {web_openid:res.data.openid};
        if(!this.user.union_id && res.data.unionid) data.union_id = res.data.unionid;
        if(!this.user.avatar && res.data.headimgurl) data.avatar = res.data.headimgurl;
        if(!this.user.name && res.data.nickname) data.name = res.data.nickname;
        this.SetUserInfo(data).then(res=>{
          if(res.code === 1) 
          {
            this.$Message.success('绑定成功')
              setTimeout(()=>{
                this.GetUserInfo().then(res=>{
                res.data.token = this.user.token;
                this.setUser(res.data);
              })
            },1000)
          }  
        })
      })
    },
    WechatUnBind(){
      this.SetUserInfo({web_openid:"",union_id:""}).then(res=>{
          if(res.code === 1) 
          {
            this.$Message.success('解绑成功')
            this.GetUserInfo().then(res=>{
              res.data.token = this.user.token;
              this.setUser(res.data);
            })
          }  
        })
    },
    DingTalkUnBind(){
      this.SetUserInfo({dd_web_openid:"",dd_unionid:""}).then(res=>{
          if(res.code === 1) 
          {
            this.$Message.success('解绑成功')
            this.GetUserInfo().then(res=>{
              res.data.token = this.user.token;
              this.setUser(res.data);
            })
          }  
        })
    },
    DingTalkBind(code){
      this.$Spin.show();
      this.DingTalkLogin({ code,is_site:1 }).then(res => {
        this.$Spin.hide();
         if (res.code === 5) {
          this.DingTalk = res.data;
        let data = {dd_web_openid:res.data.dd_web_openid};
        if(!this.user.dd_unionid && res.data.unionid) data.union_id = res.data.unionid;
        if(!this.user.name && res.data.nickname) data.name = res.data.nickname;
        this.SetUserInfo(data).then(res=>{
          if(res.code === 1) 
          {
            this.$Message.success('绑定成功')
              setTimeout(()=>{
                this.GetUserInfo().then(res=>{
                res.data.token = this.user.token;
                this.setUser(res.data);
              })
            },1000)
          }  
        })


        } 
      }); 
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>